export default class AdminTourTable {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT AdminTourTable');
		$('button.button-link.editinline').on('click', () => {
			setTimeout(() => {
				$('tr.quick-edit-row input[name="post_name"]').prop('disabled', true);
			}, 10);
		});
	}
}
